import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, SelectField, ToolbarComponent } from '../../../../../components'
import { classHeadCells } from '../../../../../shared/data/headCells'
import { AddClass } from './components/AddClass'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { useDispatch, useSelector } from 'react-redux'
import { AddSection } from './components/AddSection'
import { InfoField } from '../School/PopOver/SchoolInfo'
import UpdateClass from './components/UpdateClass'
import { highestInt } from '../../../../../shared/utils/constants'
import { setOpenAddClass } from '../../../../../redux/globalSlice'

const Class = () => {
  const dispatch = useDispatch()
  const [page, setPage] = React.useState(1)
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const [update, setUpdate] = useState(false)
  const [schoolName, setSchoolName] = React.useState('')
  // const [addClass, setAddClass] = useState(false)
  const addClass = useSelector((state) => state.global.openAddClass)
  // const search = useSelector((state) => state.global.searchItem)
  const [search, setSearch] = useState('')

  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  const openSection = useSelector((state) => state.global.openSection)
  const {
    data: classData,
    count,
    refetch,
  } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${schoolName ? schoolName : userSchoolId}&page=${page}&limit=${rowsPerPage}`,
  })
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const no_data_msg =
    customRole == 'Admin'
      ? 'Add class to start over'
      : schoolName
        ? 'Add class to start over'
        : 'Select school to see classes'
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Class'} subtitle={'Class / Class'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>

        <ToolbarComponent
          // search={search}
          setPage={setPage}
          classView
          // setSearchItem={setSearch}
          handleOpen={() => dispatch(setOpenAddClass(true))}
        >
          {/* <FilterSection icon={FilterIcon} title={'Filter'} /> */}
          {/* <FilterSection icon={ExportIcon} title={'Export'} /> */}
        </ToolbarComponent>
      </div>
      <DataTable
        // setUpdate={setUpdate}
        noDataMsg={no_data_msg}
        headCells={classHeadCells}
        classTable
        rowData={classData}
        pageFee={page}
        setPageFee={setPage}
        pageCount={count}
        pages
        setUpdate={setUpdate}
        refetch={refetch}
      />
      {addClass && (
        <AddClass
          customRole={customRole}
          userSchoolId={userSchoolId}
          open={addClass}
          handleClose={() => dispatch(setOpenAddClass(false))}
          refetch={refetch}
        />
      )}
      {update && (
        <UpdateClass
          open={update}
          handleClose={() => setUpdate(false)}
          refetch={refetch}
        />
      )}
      {openSection && <AddSection open={openSection} schoolName={schoolName} refetch={refetch} />}
    </div>
  )
}

export default Class
